import React from "react";
import { graphql } from "gatsby";
import PropTypes from "prop-types";
import Layout from "../components/layout";
import Article from "../components/news/Article";

export default function Template({
 data // this prop will be injected by the GraphQL query below.
}) {
  console.log("Template", data);
  return (
    <Layout>
      <div className='body'>
        <Article data={data.allFile.edges} />
      </div>
    </Layout>
  );
}

Template.propTypes = {
  data: PropTypes.object
};

export const pageQuery = graphql`
  query($index: Int) {
    allFile(filter: {relativeDirectory: {eq: "news"}, childMarkdownRemark: {frontmatter: {index: {eq: $index}}}}) {
      edges {
        node {
          childMarkdownRemark {
          html
            frontmatter {
              title
              date
              image
            }
          }
        }
      }
    }
  }
`;